import * as React from 'react';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { Store } from './stores';
import { FeedWidget } from './FeedWidget';

export interface IProps {
  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  component: "IntraActive-Messages" | "IntraActive-Events";
}

export class IAFeedWidget extends React.Component<IProps> {

  private store: Store;

  constructor(props: IProps) {
    super(props);
    this.store = new Store();
    this.store.environment = props.environment;
    this.store.tenant = props.tenant;
    this.store.token = props.token;
    this.store.component = props.component;
    this.store.currentFeed = {
      application: props.component === "IntraActive-Messages" ? 'messages' : 'events',
      instances: [],
      title: ''
    }
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
  }

  public componentWillReceiveProps(props: IProps) {
    console.log(props);
    // if (this.store.token != props.token) {
    //   this.store.token = props.token;
    // }
  }

  public render(): JSX.Element {
    return (
      <Provider store={this.store}>
        <FeedWidget />
      </Provider>
    );
  }
  
}